import React, { useEffect } from "react";
import CompletedJobCard from "./components/CompletedJobCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompletedJobsForVendor } from "../../../redux/slices/vendorJobSlice";

const CompletedJob = () => {
  const dispatch = useDispatch();
  const { vendorId } = useSelector((state) => state.vendorAuth);
  useEffect(() => {
    if (vendorId) {
      dispatch(fetchCompletedJobsForVendor(vendorId));
    }
  }, [vendorId, dispatch]);
  return (
    <div>
      <CompletedJobCard />
    </div>
  );
};

export default CompletedJob;
